import { tg } from "./sdk";

/**
 * The classic Mini App layout bug: `window.innerHeight` in Telegram's
 * webview includes area that gets covered by the client's own UI chrome
 * as it animates/resizes, so anything sized off it jumps or clips.
 * `viewportStableHeight` is the settled, safe value. We publish it as a
 * CSS custom property so layout can use `var(--tg-viewport-height)`
 * instead of `100vh` / `100dvh` anywhere it matters, and keep it live via
 * the `viewportChanged` event (keyboard open/close, chrome resize, etc.).
 */
export function initViewport(): void {
  const apply = () => {
    const height = tg?.viewportStableHeight ?? window.innerHeight;
    document.documentElement.style.setProperty("--tg-viewport-height", `${height}px`);
  };

  apply();

  if (tg) {
    tg.onEvent("viewportChanged", apply);
  } else {
    // Plain-browser fallback for local dev/testing outside Telegram.
    window.addEventListener("resize", apply);
  }
}
